export default "__VITE_ASSET__a14dca18__"